import { styled } from '@material-ui/core';

const TrajectoryWrapper = styled('div')({
  flex: 1,
  alignSelf: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  '.info': {
    display: 'flex',
    alignItems: 'center',
    margin: '1rem 0',
    '>*': {
      marginRight: '1rem',
    },
  },
});

export default TrajectoryWrapper;
